import React, { useEffect, useState } from "react";
import {
  MdBookmark,
} from "react-icons/md";
import FilterPopup from "./Components/filterPopup";
import { useStores } from "../../store";
import ReactPaginate from "react-paginate";
import { useObserver } from "mobx-react";
import userpic from "../../assests/userprofiledefaultpic.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { interviewStatus } from "../../services/reusable";
import LoadingAnime from "../reusble_components/loadingAnime";
import * as XLSX from "xlsx";
import { apiGet } from "../../api/api_methods";
import ApplicantLabelPopup from "./Resume/applicant_labelPopup";
import TotalApplicant from "../reusble_components/TotalApplicant";
import TotalApplicant2 from "../reusble_components/totalApplicant2";
import Applicants from "../reusble_components/ApplicantsSearch";
import { toJS } from "mobx";
import TotalApplicantsMobile from "../reusble_components/TotalApplicant3";

const statusColors = {
  rejected: "bg-red-200 text-red-600",
  shortlisted: "bg-green-200 text-green-600",
  onhold: "bg-yellow text-yellow",
  hired: "bg-green-200 text-green-600",
  pending: "bg-yellow text-yellow",
};

const scoreColor = (score) => {
  if (score < 50) return "text-red-600";
  else if (score > 50 && score < 75) return " text-yellow";
  else return "text-green-600";
};

const Card = ({ title, count, icon, color }) => (
  <div className="items-center justify-between p-4 bg-white rounded-lg shadow-2xl shadow-slate-200 h-36">
    <div className="flex mt-2">
      <div className={`text-2xl ${color}`}>{icon}</div>
      <h3 className="text-lg font-semibold ml-1">{title}</h3>
    </div>
    <p className={`text-5xl ml-5 mt-2 ${color}`}>{count}</p>
  </div>
);

const timestampToDate = (timestamp) => {
  const date = new Date(timestamp);
  return date.toISOString().split("T")[0];
};

const getScore = (data) => {
  const techObj = data?.technicalInterview?.result.find(
    (ele) => ele.name === "average_technical_score"
  );
  const hrObj = data?.hrInterview?.result.find(
    (ele) => ele.name === "average_technical_score"
  );
  const hr = hrObj ? hrObj?.score : 0;
  const tech = techObj ? techObj?.score : 0;
  return (tech + hr) / 2;
};

const Table = ({ data }) => {
  const { PopupStore, LabelStore } = useStores();
  const navigate = useNavigate();
  const getstatus = (data) => {
    if (data.isShortlisted) {
      return "Shortlisted";
    } else if (data.isRejected) {
      return "Rejected";
    } else {
      if (interviewStatus(data)) return "Hold";
      else return "Pending";
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full mt-4 bg-white rounded shadow-sm">
        <thead className="bg-[#FFE9D9] rounded-2xl h-14">
          <tr>
            <th className="px-4 py-2 font-medium">Profile pic</th>
            <th className="px-4 py-2 font-medium">Name</th>
            <th className="px-4 py-2 font-medium">Email ID</th>
            <th className="px-4 py-2 font-medium">Applied date</th>
            <th className="px-4 py-2 font-medium">Applied for</th>
            <th className="px-4 py-2 font-medium">Total Score</th>
            <th className="px-4 py-2 font-medium">Status</th>
            <th className="px-4 py-2 font-medium">Save</th>
          </tr>
        </thead>
        {data?.length === 0 && (
          <tr className="border-b items-center justify-center font-bold text-primary text-2xl text-center">
            <td colSpan="8" className="py-2 px-2 h-24 md:pl-5 lg:pl-10">
              No Applicants Found
            </td>
          </tr>
        )}
        <tbody>
          {data?.map((applicant, index) => (
            <tr className="border-b cursor-pointer items-center justify-center px-5">
              <td key={index} className="px-2 md:pl-5 lg:pl-10 py-2">
                <img
                  className="h-12 w-12 md:h-12 md:w-12 lg:h-14 lg:w-14 rounded-full"
                  src={applicant.userId?.pic ? applicant.userId.pic : userpic}
                  alt={`Profile of ${applicant.userId?.name}`}
                  onError={(e) => {
                    e.target.src = userpic;
                  }}
                />
              </td>
              <td
                className="px-2 md:pl-10 lg:pl-20  py-2"
                onClick={() => {
                  navigate(
                    `../job-applicants/${applicant?.jobPostId?._id}?applicant=${applicant?._id}`
                  );
                }}
              >
                {applicant.userId?.name}
              </td>
              <td className="px-2 md:pl-12 lg:pl-32 py-2">
                {applicant.userId?.mail}
              </td>
              <td className="px-2 md:pl-5 lg:pl-20 py-2">
                {timestampToDate(applicant.createdAt)}
              </td>
              <td className="px-2 md:pl-5 lg:pl-20 py-2">
                {applicant.jobPostId?.jobTitle}
              </td>
              <td
                className={`px-2 md:pl-12 lg:pl-16 py-2 ${scoreColor(
                  applicant?.averageScore
                )}  `}
              >
                {applicant?.averageScore}
              </td>
              <td className="px-2 md:pl-6 lg:px-0 lg:pl-10 py-2">
                <span
                  className={`px-2 py-1  rounded text-xs ${
                    statusColors[applicant.status]
                  }`}
                >
                  {applicant.status}
                </span>
              </td>
              <td
                className="text-center items-center cursor-pointer"
                onClick={() => {
                  LabelStore.setApplicantId(applicant?._id);
                  console.log(LabelStore.ApplicantId);
                  LabelStore.setsection("application");
                  LabelStore.setApplicantLabelArray(applicant.labels);
                  console.log(LabelStore.Applicants);
                  LabelStore.setApplicants(true);
                }}
              >
                {applicant?.labels && applicant?.labels[0] ? (
                  <MdBookmark className="mx-auto text-2xl text-primary" />
                ) : (
                  <MdBookmark className="mx-auto text-2xl text-gray-300" />
                )}
              </td>
            </tr>
          ))}
        </tbody>
        {ObservablepopupComponent()}
      </table>
    </div>
  );
};

const ObservablepopupComponent = () => {
  return useObserver(() => (
    <div>
      <ApplicantLabelPopup />
    </div>
  ));
};

const CompanyApplicants = () => {
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [filters, setFilters] = useState({});
  const { RecuiterStore } = useStores();
  const [loader, setLoader] = useState(false);

  const handleOpenFilterPopup = () => {
    setShowFilterPopup(true);
  };

  const handleCloseFilterPopup = () => {
    setShowFilterPopup(false);
  };

  const shouldShowResetButton = () => {
    const { interviewType, appliedDate, appliedFor, status, score, completionStatus } =
      RecuiterStore;
    return (
      interviewType !== "" ||
      appliedDate !== "" ||
      appliedFor !== "" ||
      status !== "" ||
      score !== "" ||
      completionStatus !== ""
    );
  };

  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
    RecuiterStore.setInterviewType(appliedFilters?.interviewType);
    RecuiterStore.setAppliedFor(appliedFilters?.jobTitle);
    RecuiterStore.setScore(appliedFilters?.totalScore);
    RecuiterStore.setStatus(appliedFilters?.status);
    RecuiterStore.setCompletionStatus(appliedFilters?.completionStatus);
    RecuiterStore.setAppliedDate(appliedFilters?.appliedDate);
    
    // Reset to first page when applying filters and fetch data
    const currentPage = 0;
    navigate(`/company/talent-pool?page=${currentPage}`);
    RecuiterStore.setPreviousPageForTalentPool(currentPage);
    RecuiterStore.fetchapplicants(currentPage * 10);
  };
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = query.get("page") || 0;
  // useEffect(() => {
  //   if (page === null || page === undefined) {
  //     return;
  //   } else {
  //     alert(1)
  //     fetchApplicants(page * 10);
  //   }
  // }, [page]);

  useEffect(() => {
    // navigate(`/company/talent-pool?page=${RecuiterStore.previousPageForTalentPool}`)
    if (RecuiterStore.refreshObject.talentPool === 0) {
      const currentPage = parseInt(page) || 0;
      fetchApplicants(currentPage * 10);
      RecuiterStore.refreshObject.talentPool = 1;
    }
  }, []);

  useEffect(() => {
    console.log("karthik");
    if (RecuiterStore.refreshObject.talentPool === 0) {
      const currentPage = parseInt(page) || 0;
      RecuiterStore.fetchapplicants(currentPage * 10);
    }
  }, [RecuiterStore.status]);
  const navigate = useNavigate();

  useEffect(() => {
    // if (RecuiterStore.tractionData === null) { 
      fetchTraction();
    // }
  }, []);

  // Handle URL changes for pagination
  useEffect(() => {
    const currentPage = parseInt(page) || 0;
    if (currentPage !== RecuiterStore.previousPageForTalentPool) {
      RecuiterStore.setPreviousPageForTalentPool(currentPage);
      fetchApplicants(currentPage * 10);
    }
  }, [page]);

  const handlePageClick = async (event) => {
    setLoader(true);

    const selectedPage = event.selected;
    const skip = selectedPage * 10;
    
    // Update URL first
    navigate(`/company/talent-pool?page=${selectedPage}`);
    
    // Update store state
    RecuiterStore.setPreviousPageForTalentPool(selectedPage);
    
    // Fetch data with correct skip value
    await fetchApplicants(skip);
  };

  const id = JSON.parse(localStorage.getItem("user"))?._id;

  const fetchTraction = async () => {
    const res = await apiGet(`/application/improvement/${id}`);
    if (res.status === 200) {
      RecuiterStore.setTractionData(toJS(res.body));
      console.log(toJS(RecuiterStore.tractionData), "ghsgfjhsghjshs");
    } else {
      console.log(res.status);
    }
  };

  const fetchApplicants = async (skip) => {
    const res = await RecuiterStore.fetchapplicants(skip);
    if (res) {
      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  const data = [
    { name: "John", age: 28, city: "New York" },
    { name: "Anna", age: 22, city: "London" },
    { name: "Mike", age: 32, city: "Paris" },
  ];

  const exportToExcel = async () => {
    const limit = prompt("Enter the number of applicants you want to export");
    if (!limit) return;
    let data = [];

    const id = JSON.parse(localStorage.getItem("user"))?._id;
    let timestamp = "";
    if (RecuiterStore.appliedDate != "") {
      const date = new Date(RecuiterStore.appliedDate);
      timestamp = date.getTime();
    }
    RecuiterStore.setLoader(true);
    const response = await apiGet(
      `/application/applicants?recruiterId=${id}&skip=${0}&limit=${Number(
        limit
      )}&clientId=${RecuiterStore.clientId}&interviewType=${
        RecuiterStore.interviewType
      }&appliedFor=${RecuiterStore.appliedFor}&score=${
        RecuiterStore.score
      }&status=${RecuiterStore.status}&appliedDate=${timestamp}&searchFilter=${
        RecuiterStore.applicantSearch
      }`
    );
    // this.loader = false;
    RecuiterStore.setLoader(false);
    if (response.status === 200) {
      console.log(response.body.data);
      data = response.body.data.map((applicant) => {
        return {
          Name: applicant?.userId?.name,
          Email: applicant?.userId?.mail,
          "Applied Date": timestampToDate(applicant.createdAt),
          "Applied For": applicant?.jobPostId?.jobTitle,
          "Total Score": applicant?.averageScore,
          Status: applicant?.status,
          resume: applicant?.resume,
        };
      });
      console.log(data);
    } else {
      return alert("Error in fetching data");
    }

    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and download
    XLSX.writeFile(workbook, "table_data.xlsx");
  };

  return useObserver(() => {
    const Card = ({ title, count, icon, color }) => (
      <div className="items-center justify-between p-4 bg-white rounded-lg shadow-2xl shadow-slate-200 h-36">
        <div className="flex mt-2 mb-5">
          <div className={`text-2xl ${color}`}>{icon}</div>
          <h3 className="text-lg font-semibold ml-1">{title}</h3>
        </div>
        {RecuiterStore.loader ? (
          <LoadingAnime
            page={"applicants"}
            numBoxes={1}
            boxWidth="4rem"
            boxHeight="3rem" // Adjust height as needed for a rectangle
            gridColumns="grid-cols-1"
            bgColor="bg-gray-200"
            innerBoxes={[]} // No inner boxes needed
          />
        ) : (
          <span className={`text-5xl ml-5 ${color}`}>{count}</span>
        )}
      </div>
    );

    return (
      <div className="md:p-4 p-4 bg-white h-screen gil-reg">
        {/* <Loader loader={loader ? loader : RecuiterStore.loader} /> */}
        <Applicants />
        {/* <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mb-8 ">
          <div>
            <Card
              title="Total Applicants"
              count={RecuiterStore?.jobapplicants?.count?.totalApplicants}
              icon={<PiStudent />}
              color="text-orange-500"
            />
          </div>
          <div>
            <Card
              title="Short listed"
              count={RecuiterStore?.jobapplicants?.count?.shortlistedCount}
              icon={<GoVerified />}
              color="text-[#E7AF20]"
            />
          </div>
          <div>
            <Card
              title="Hired"
              count={RecuiterStore?.jobapplicants?.count?.hiredCount}
              icon={<PiSuitcaseSimple />}
              color="text-green-500"
              showCountWhileLoading={true}
            />
          </div>
          <div>
            <Card
              title="On Hold"
              count={RecuiterStore?.jobapplicants?.count?.onholdCount}
              icon={<PiPlaceholder />}
              color="text-red-500"
              showCountWhileLoading={true}
            />
          </div>
        </div> */}

        <div className="h-fit md:block hidden">
          <TotalApplicant
            totalApplicants={
              RecuiterStore?.jobapplicants?.counts?.totalApplicantsCount
            }
            shortListed={
              RecuiterStore?.jobapplicants?.counts?.totalShortlistCount
            }
            onHold={RecuiterStore?.jobapplicants?.counts?.totalOnHoldCount}
            hired={RecuiterStore?.jobapplicants?.counts?.totalHiredCount}
            rejected={RecuiterStore?.jobapplicants?.counts?.totalRejectCount}
            shortlistPercentage={RecuiterStore.tractionData.shortlistPercentage}
            rejectPercentage={RecuiterStore.tractionData.rejectPercentage}
            onHoldPercentage={RecuiterStore.tractionData.onHoldPercentage}
            hiredPercentage={RecuiterStore.tractionData.hiredPercentage}
          />
        </div>
        <div className="h-fit md:hidden block">
          <TotalApplicantsMobile
            totalApplicants={
              RecuiterStore?.jobapplicants?.counts?.totalApplicantsCount
            }
            shortListed={
              RecuiterStore?.jobapplicants?.counts?.totalShortlistCount
            }
            onHold={RecuiterStore?.jobapplicants?.counts?.totalOnHoldCount}
            hired={RecuiterStore?.jobapplicants?.counts?.totalHiredCount}
            rejected={RecuiterStore?.jobapplicants?.counts?.totalRejectCount}
            shortlistPercentage={RecuiterStore.tractionData.shortlistPercentage}
            rejectPercentage={RecuiterStore.tractionData.rejectPercentage}
            onHoldPercentage={RecuiterStore.tractionData.onHoldPercentage}
            hiredPercentage={RecuiterStore.tractionData.hiredPercentage}
          />
        </div>

        {/* <div className="flex justify-between gap-4 items-center mb-4"> */}
        {/* <h2 className="md:text-xl text-lg "></h2> */}
        {/* <div
            className="hidden md:flex relative justify-start items-center w-[50%] py-3 px-6 rounded-full  "
            style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)" }}
          > */}
        {/* <input
              type="text"
              placeholder="Search by Role"
              onChange={(e) => {
                if (e.target.value === "") {
                  RecuiterStore.setApplicantSearch(e.target.value);
                  RecuiterStore.fetchapplicants();
                }
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  console.log(e.target.value);

                  RecuiterStore.setApplicantSearch(e.target.value);
                  RecuiterStore.fetchapplicants();
                }
              }}
              className=" placeholder-primary bg-transparent truncate text-md md:text-lg outline-none h-10 w-[90%] md:w-[95%]"
            /> */}
        {/* <CiSearch className="text-4xl text-primary absolute right-4 md:right-6 " /> */}
        {/* </div> */}
        {/* <div className="flex  space-x-2 "> */}
        {/* <button className="p-2 border border-black rounded flex w-[100%] justify-center items-center"><HiOutlineAdjustmentsHorizontal className="mr-1"/> Filter</button> */}
        {/* <div className="flex items-center  gap-4 -mb-0"> */}
        {/* <button
                onClick={handleOpenFilterPopup}
                className="p-2 relative  rounded flex text-2xl justify-center gap-3 items-center"
              > */}
        {/* <div className="relative">
                  <HiOutlineAdjustmentsHorizontal />
                  {shouldShowResetButton() && (
                    <p className="bg-primary absolute rounded-full h-3 w-3 bottom-0 right-0"></p>
                  )}
                </div> */}
        {/* {shouldShowResetButton() && (
                  // <button
                  //   className="text-sm  absolute -bottom-4 hover:underline text-primary "
                  //   onClick={(e) => {
                  //     e.stopPropagation();
                  //     RecuiterStore.resetFilter();
                  //   }}
                  // >
                  //   Reset
                  // </button>
                )} */}
        {/* </button> */}
        {/* <AiOutlineExport
                className="text-2xl cursor-pointer"
                onClick={exportToExcel}
              /> */}
        {/* </div> */}
        {/* <select className="p-2 border border-black rounded w-[60%]">
              <option>All interviews</option>
            </select> */}
        {/* </div> */}
        {/* </div> */}
        <div></div>
        {/* <div
          className="flex md:hidden relative justify-start items-center w-[100%] py-3 mt-8 px-6 rounded-full  "
          style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)" }}
        >
          <input
            type="text"
            placeholder="Search by Role or Technology"
            // onChange={(e)=>{console.log(e.target.value)}}
            onChange={(e) => {
              if (e.target.value === "") {
                RecuiterStore.setApplicantSearch(e.target.value);
                RecuiterStore.fetchapplicants();
              }
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                console.log(e.target.value);

                RecuiterStore.setApplicantSearch(e.target.value);
                RecuiterStore.fetchapplicants();
              }
            }}
            className=" placeholder-primary bg-transparent truncate text-md md:text-lg outline-none h-10 w-[90%] md:w-[95%]"
          />
          <CiSearch className="text-4xl text-primary absolute right-4 md:right-6 " />
        </div> */}
        {/* {RecuiterStore.loader ? (
          <TableShimmer numRows={8} />
        ) : ( */}
        <TotalApplicant2 data={RecuiterStore?.jobapplicants?.data} />
        {/* )} */}
        {(RecuiterStore?.status === 1
          ? RecuiterStore?.jobapplicants?.counts?.totalShortlistCount
          : RecuiterStore?.status === 2
          ? RecuiterStore?.jobapplicants?.counts?.totalOnHoldCount
          : RecuiterStore?.status === 3
          ? RecuiterStore?.jobapplicants?.counts?.totalHiredCount
          : RecuiterStore?.status === 4
          ? RecuiterStore?.jobapplicants?.counts?.totalRejectCount
          : RecuiterStore?.jobapplicants?.counts?.totalApplicantsCount) >
          10 && (
          <div className="mb-10">
            <ReactPaginate
              nextLabel=" >"
              className="flex justify-center items-center gap-5   my-4 "
              onPageChange={handlePageClick}
              forcePage={parseInt(page) || 0}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={Math.ceil(
                (RecuiterStore?.status === 1
                  ? RecuiterStore?.jobapplicants?.counts?.totalShortlistCount
                  : RecuiterStore?.status === 2
                  ? RecuiterStore?.jobapplicants?.counts?.totalOnHoldCount
                  : RecuiterStore?.status === 3
                  ? RecuiterStore?.jobapplicants?.counts?.totalHiredCount
                  : RecuiterStore?.status === 4
                  ? RecuiterStore?.jobapplicants?.counts?.totalRejectCount
                  : RecuiterStore?.jobapplicants?.counts
                      ?.totalApplicantsCount) / 10
              )}
              previousLabel={(parseInt(page) || 0) <= 0 ? "" : "< "}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active-page-item"
              activeLinkClassName="active-page-link"
              renderOnZeroPageCount={null}
            />
          </div>
        )}
        <div className="md:hidden lg:hidden flex py-5"></div>

        <FilterPopup
          show={showFilterPopup}
          onClose={handleCloseFilterPopup}
          onApply={handleApplyFilters}
        />
      </div>
    );
  });
};

export default CompanyApplicants;
